import { FaDollarSign, FaGlobe, FaSignal, FaTools, FaWifi } from "react-icons/fa";
import images from "./images";

const About = {
  sub: "About Us",
  heading: "Your Trusted Partner for Seamless Connectivity",
  description: [
    "Welcome to Netify, your reliable provider for high-speed internet, cable TV, and broadband services. We are dedicated to delivering fast, dependable, and high-quality connectivity solutions to keep you connected. Our team of experts ensures that your experience is smooth and hassle-free.",
  ],
  experience: {
    icon: <FaGlobe />,
    year: "30+ years",
    text: "quality experience",
  },
  points: [
    {
      icon: <FaSignal />,
      title: "High-Speed Internet",
    },
    {
      icon: <FaWifi />,
      title: "Premium Cable Channels",
    },
    {
      icon: <FaTools />,
      title: "24/7 Customer Support",
    },
    {
      icon: <FaDollarSign />,
      title: "Competitive Pricing",
    },
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "About-Image-1",
    alt2: "About-Image-2",
  },
  button: {
    text: "Get Started",
    link: "Pricing",
  },
};

export default About;